var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavoritActive = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.386 5h.23a4.529 4.529 0 0 1 3.277 1.542c1.548 1.757 1.45 4.493-.155 6.287l-.15.16-5.409 5.525c-.6.614-1.571.646-2.21.097l-.104-.097-5.547-5.667a4.637 4.637 0 0 1-1.316-3.365 4.63 4.63 0 0 1 1.492-3.29c1.747-1.607 4.496-1.504 6.276.162l.154.151.098.1.237-.242a4.531 4.531 0 0 1 2.684-1.33l.218-.022.225-.011Z",
  fill: "#F68A20",
  fillRule: "nonzero"
})));
export default SvgFavoritActive;